import { AxiosPromise } from 'axios';
import { IGetEvaluations, IEvaluationReq } from '../models/evaluationCourse.model';
import axios from 'axios';

const uri = '/mgmt/evaluation/course';

export const getEvaluations = (courseCode: number): AxiosPromise<IGetEvaluations> => {
  return axios.get(`${uri}/${courseCode}`);
}

// 교육과정 - 맵핑된 평가항목 조회
export const getSemesterEvaluations = (semesterCourseCode: number): AxiosPromise<IGetEvaluations> => {
  return axios.get(`/mgmt/evaluation/item/semester-seq/${semesterCourseCode}`);
}

export const createEvaluation = (courseCode: number, data: IEvaluationReq): AxiosPromise => {
  return axios.post(`${uri}/${courseCode}`, data);
};

export const updateEvaluation = (courseEvaluationCode: number, data: IEvaluationReq): AxiosPromise => {
  return axios.put(`${uri}/${courseEvaluationCode}`, data);
};

export const copyEvaluations = (courseCode: number, targetCourseCode: number): AxiosPromise => {
  return axios.post(`${uri}/copy/${courseCode}/${targetCourseCode}`);
};
